// extracted by mini-css-extract-plugin
export default {"menu_bar":"Header_menu_bar__72TIb","btnPrev":"Header_btnPrev__+hQqW","logo":"Header_logo__eQM7L"};